import { Injectable, Injector } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class TpaGuard implements CanActivate {
  public canActivate() {
    let userProfile = JSON.parse(sessionStorage.getItem('user') || '{}');
    if (!userProfile || !userProfile.security || !userProfile.security.terminalAndPrinterTab)
      return false;
    else return true;
  }

  // canActivateChild() {}
}